import get from 'lodash/fp/get'
import pipe from 'lodash/fp/pipe'

export const getSelectedFieldTabs = get('selectedFieldTabs')

export const getAllSelectedFieldTabs = pipe(getSelectedFieldTabs, get('tabs'))

export const getSelectedFieldTab = pipe(getSelectedFieldTabs, get('activeTabIndex'))
